import { render, staticRenderFns } from "./FilterRestrictions.vue?vue&type=template&id=2375d7f0&"
import script from "./FilterRestrictions.vue?vue&type=script&lang=js&"
export * from "./FilterRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports